/** Recherche-Mail (Sammelmail) an eine Zulassungsstelle. */
export default class VehicleRegistrationInquiry {
  id?: string
  officePersonId?: string
  /** Name der Zulassungsstelle (Organisationsstruktur), sonst der Gruppierungsschlüssel */
  officeName?: string
  officeKey?: string
  mailTypeId?: string
  mailTypeText?: string
  /** Draft, Approved, Sent, Failed, Discarded */
  statusId?: string
  statusText?: string
  recipients?: string
  subject?: string
  bodyText?: string
  errorText?: string
  createDate?: Date
  approvedDate?: Date
  sentDate?: Date
  /** angefragte (unbekannte) Zulassungen */
  unknownCount?: number
  /** alle Zulassungen der Mail inkl. mitgeführter */
  itemCount?: number
  /** false = Versand ohne Excel-Liste */
  attachExcel?: boolean
}

export class VehicleRegistrationInquiryItem {
  id?: string
  vehicleRegistrationId?: string
  kennzeichen?: string
  nummer?: string
  /** true = angefragte unbekannte Zulassung; false = nur zur Klärung mitgeführt */
  isUnknown?: boolean
}

export function isInquiryEditable(inquiry?: VehicleRegistrationInquiry): boolean {
  return inquiry?.statusId === "Draft" || inquiry?.statusId === "Failed"
}
